import { SocketMessageEvent } from './messages';

export interface ShowNotificationRequest {
    message: string;
    options?: {
        type?: 'error' | 'info' | 'success' | 'warning';
        title?: string;
        closeButton?: boolean;
        closeHtml?: string;
        closeMethod?: string;
        closeDuration?: number;
        closeEasing?: string;
        timeOut?: number;
        preventDuplicates?: boolean;
        extendedTimeOut?: number;
        data?: any;

        onShown?: () => void;
        onHidden?: () => void;
        onClick?: () => void;
        onCloseClick?: () => void;
    };
}

export const displayNotificationSocketEvent = new SocketMessageEvent<ShowNotificationRequest>('ui.notify');
